import React from 'react';
import { WizardStepProps } from '../WizardStepProps';
import { eSigningMethod } from '../../../../../types/signingAppointment/eSigningMethod';
import { ConfirmationStep } from '../04_confirmationStep/ConfirmationStep';
import { NotaryStep } from './notaryStep/NotaryStep';
import { ProgressStep } from '../shared/WizardProgress';
import { SignersStep } from '../02_signersStep/SignersStep';
import { NotesStep } from './notesStep/NotesStep';

interface MethodStepProps extends WizardStepProps {
  previous?: ProgressStep;
}

const requiresNotes = new Set<string>([eSigningMethod.wetSign, eSigningMethod.attorney, eSigningMethod.ron]);
export const hasNotesStep = (signingMethod?: string, signerWillProvideLocation?: boolean) => {
  if (!signingMethod || signerWillProvideLocation) return false;
  return requiresNotes.has(signingMethod);
};

// Redirects
export const MethodStep: React.FC<MethodStepProps> = ({ previous, wizardFormData, ...rest }) => {
  // sometimes we "skip" over the Method Step
  if (
    wizardFormData.isSignatureSyncAppointment ||
    wizardFormData.signingMethod === eSigningMethod.eSign ||
    (wizardFormData.isDigitalScheduling && wizardFormData.signingMethod === eSigningMethod.notaryOnly)
  ) {
    if (previous === ProgressStep.CONFIRMATION) {
      return <SignersStep wizardFormData={wizardFormData} {...rest} />;
    }
    return <ConfirmationStep wizardFormData={wizardFormData} {...rest} />;
  }

  if (hasNotesStep(wizardFormData.signingMethod)) {
    return <NotesStep wizardFormData={wizardFormData} {...rest} />;
  }
  return <NotaryStep wizardFormData={wizardFormData} {...rest} />;
};
